<ng-container *transloco="let t">
  <ng-container>
    <dt> {{ t('ATTAINMENTS.ATTAINMENT_DETAILS.CURRICULUM_PERIODS') }}</dt>
    <dd>{{ (curriculumPeriods$ | async) ?? '-'  }}</dd>
  </ng-container>
</ng-container>
